import copy from 'copy-to-clipboard';

export default copy;
